import React, {useEffect, useState} from 'react';
import Layout from './layout';
import CollectionDetailsModel from '../models/collection-details';
import CollectionView from './collection-view';
import CollectionAdd from './collection-add';
import StatusView from './status-view';
import Loader from './loader';
import Error from './error';
import SandraJsAPI from "../services/sandraJsAPI";
import {StatusMessageTypeEnum} from "../enums/StatusMessageTypeEnum";
import IStatusMessage from "../models/status-message";

function Collection(): React.ReactElement {
    const emptyStatus: IStatusMessage = {message: "", type: StatusMessageTypeEnum.none}
    const collectionDetailsInit: CollectionDetailsModel = {
        collection: {
            collectionId: '',
            creationTimestamp: new Date(),
            description: '',
            image: '',
            name: '',
            imageUrl: '',
        },
        contracts: [],
    };

    const urlParams = new URLSearchParams(window.location.search);
    const collectionId = String(urlParams.get('id'));
    const addNew = String(urlParams.get('action'));

    const [isLoading, setIsLoading] = useState(true);
    const [collectionDetails, setCollectionDetails] = useState(collectionDetailsInit);
    const [statusMessage, setStatusMessage] = useState(emptyStatus);
    const [errorMessage, setErrorMessage] = useState('');

    let view = <div/>;

    const onStatusMessage = (message: string, type: StatusMessageTypeEnum) => {
        setStatusMessage({message, type});
    };

    if (addNew === 'add') {
        view = <CollectionAdd setStatusMessage={onStatusMessage}/>;
    } else {
        view = isLoading
            ? <div style={{padding: '5rem', textAlign: 'center'}}><Loader width="70px" imageNumber="0"/></div>
            : (
                <CollectionView
                    collection={collectionDetails.collection}
                    contracts={collectionDetails.contracts}
                    setStatusMessage={onStatusMessage}
                />
            );
    }

    useEffect(() => {
        if (addNew !== 'add') {
            SandraJsAPI.getCollectionDetailsAsync((collectionId))
                .then((response) => {
                    console.log(response.data);
                    if (response.error) {
                        setErrorMessage(response.error.message);
                    } else setCollectionDetails(response.data);
                    setIsLoading(false);
                })
                .catch((error) => {
                    setErrorMessage(error.message);
                    setIsLoading(false);
                });
        }
    }, []);

    return (
        <Layout className="page home ">
            <StatusView status={statusMessage}/>
            {errorMessage ? <Error header="Oops! Server says" description={errorMessage}/> : (
                <div>
                    <div className="banner"/>
                    {view}
                </div>
            )}
        </Layout>
    );
}

export default Collection;
